import { render, staticRenderFns } from "./WellSortDirectionDropdown.vue?vue&type=template&id=47e8d14c"
import script from "./WellSortDirectionDropdown.vue?vue&type=script&lang=js"
export * from "./WellSortDirectionDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports